import React from 'react'
import PropTypes from 'prop-types'
import Checkbox from '../Checkbox'

function CheckboxOption ({
  item,
  itemToString,
  isSelected,
  toggleItem,
  ...props
}) {
  return (
    <Checkbox
      key={itemToString(item)}
      value={isSelected(item)}
      label={itemToString(item)}
      onChange={() => toggleItem(item)}
      {...props}
    />
  )
}

CheckboxOption.propTypes = {
  item: PropTypes.any,
  toggleItem: PropTypes.func,
  isSelected: PropTypes.func,
  itemToString: PropTypes.func
}

export default CheckboxOption
